var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.errorData !== undefined
    ? _c(
        "div",
        {
          staticStyle: {
            height: "100%",
            display: "flex",
            "justify-content": "center",
            "align-items": "center",
          },
        },
        [
          _c("NotFoundPage", {
            attrs: {
              "error-response": _vm.errorData.errorResponse,
              "page-reload-timeout": _vm.errorData.pageReloadTimeout,
              "button-label": _vm.errorData.buttonLabel,
              "button-link": _vm.errorData.buttonLink,
              "button-is-visible": _vm.errorData.buttonIsVisible,
            },
          }),
        ],
        1
      )
    : _vm.signedIn && _vm.loaded && _vm.arePermissionsSet
    ? _c(
        "div",
        { attrs: { id: "app" } },
        [
          _c("loader"),
          _c("WaitingModal"),
          _c("pui-application-layout", {
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [_c("header-wrapper")]
                  },
                  proxy: true,
                },
                _vm.currentSidebar.shouldShowSidebar && !_vm.$route.meta.hideNav
                  ? {
                      key: "left",
                      fn: function () {
                        return [
                          _c(
                            "nav",
                            { staticStyle: { height: "100%" } },
                            [
                              _c(
                                "pui-side-panel",
                                {
                                  staticStyle: { "z-index": "1" },
                                  attrs: {
                                    open: _vm.leftPanelIsOpen,
                                    title: "",
                                    width: "38rem",
                                    id: "globalLeftSidePanel",
                                    "floating-trigger": false,
                                    "trigger-position": "right",
                                  },
                                  on: {
                                    "update:open": function ($event) {
                                      _vm.leftPanelIsOpen = $event
                                    },
                                  },
                                },
                                [
                                  _c("filter-panel", {
                                    attrs: {
                                      component:
                                        _vm.currentSidebar
                                          .currentSidebarComponent,
                                      "component-properties":
                                        _vm.currentSidebar
                                          .sidebarComponentProperties,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                {
                  key: "main",
                  fn: function () {
                    return [
                      _c(
                        "main",
                        {
                          staticStyle: {
                            display: "grid",
                            height: "100%",
                            "place-items": "center",
                          },
                        },
                        [_c("router-view", { key: _vm.$route.fullPath })],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }